cv.getScrollableContainer = function(){
  return $('.editor-window .text-block-toolbar').get(0);
};